import { Component, Vue,} from 'vue-property-decorator'
import WorkResultByEmployee from './WorkResultByEmployee/WorkResultByEmployee.vue'
import WorkResultByFields from './WorkResultByFields/WorkResultByFields.vue'
import WorkResultByPlantings from './WorkResultByPlantings/WorkResultByPlantings.vue'


@Component({
    components: {
        WorkResultByEmployee,
        WorkResultByFields,
        WorkResultByPlantings,
    }
})
export default class WorkResult extends Vue {
    navItem = "employee"
      private isListWorkInert = false

    mounted() {
        this.$watch('$store.getters.currentPageName', this.currentMenu, { immediate: true });
    }

    currentMenu(){
        const path = this.$route.path
        const pathList = path.split('/')
        this.navItem = pathList[3]
    }

    handleInert(val: boolean) {
        this.isListWorkInert = val
    }
}